module.exports = __webpack_public_path__ + "895fb84f7ac692898d3876e9878dbd27.jpg";